import {Component} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {MieterDaten} from '../../models/mieter-daten.model';
import {PageComponent} from '../../page.component';

@Component({
  selector: 'mp-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.css']
})
export class HomeComponent extends PageComponent {
  public dataList: MieterDaten[];
  public data: MieterDaten;
  public wohnungSelected: boolean;
  public hasMultipleWohnungen: boolean;

  constructor(private apiService: ApiService) {
    super();

    this.dataList = apiService.currentMieterListValue;
    this.data = this.dataList[0];
    this.hasMultipleWohnungen = this.dataList.length > 1;

    if (!this.hasMultipleWohnungen) {
      this.selectWohnung(this.data);
    }

    if (apiService.currentMieterDatenValue != null) {
      this.selectWohnung(this.apiService.currentMieterDatenValue);
    }
  }

  filteredDataList(): MieterDaten[] {
    return this.dataList.filter(x => x.status === 200);
  }

  canGoBack(): boolean {
    return false;
  }

  selectWohnung(d: MieterDaten): void {
    if (d.status !== 200) {
      return;
    }

    this.data = d;
    this.apiService.selectMieterDaten(d);
    this.wohnungSelected = true;
  }

  getErrStartDateStr(d: MieterDaten): string {
    return new Date(d.error.startDate).toLocaleDateString('de-DE');
  }
}
